import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PermissaoService } from '../services/permissao.service';
import { EnumPermissao } from '../enums/permissoes.enum';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private permissaoService: PermissaoService,
    private router: Router,
    private toastr: ToastrService
  ) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.getToken()) {
      this.toastr.warning('Faça login para continuar');
      this.router.navigate(['/login']);
      return false;
    }

    const tempoRestante = this.authService.tempoRestanteToken();
    if(tempoRestante <= 0) {
      this.toastr.warning('Sua sessão expirou. Por favor, faça login novamente.');
      setTimeout(() => {
        this.authService.logout();  
      }, 3000);        
      return false;
    }
    
    const requiredPermission = route.data['permission'] as EnumPermissao;
    if (requiredPermission && !this.permissaoService.hasPermission(requiredPermission)) {
      this.exibirAlertaAcessoNaoAutorizado();
      this.router.navigate(['/area-logada/home']);
      return false;
    }
    
    if (route.data['requiresSaldo'] === true) {
      this.authService.atualizarSaldo().then(saldo => {
        if (saldo.quantidade <= 0) {
          this.exibirAlertaSaldoInsuficiente();
          this.router.navigate(['/area-logada/home']);
          return false;
        }
        return true;
      });
    }
    
    return true;
  }
  
  private exibirAlertaAcessoNaoAutorizado(): void {
    this.toastr.warning("Acesso não autorizado");
    setTimeout(() => {
      this.toastr.clear();
    }, 3000);
  }
  
  private exibirAlertaSaldoInsuficiente(): void {
    this.toastr.warning('Saldo insuficiente para acessar esta funcionalidade');
    setTimeout(() => {
      this.toastr.clear();
    }, 3000);
  }
}